import { getApiUrl } from 'client/modules/Url';

export type FetchStationTopPlayedEpisodesResponse = {
  data: {
    columnHeaders: {
      name: string;
      type: string;
    }[];
    rows: [string, number, number][]; // [name, numOfPlays, dateTimestamp]
  };
  kind: 'topEpisodes';
  parameters: {
    limit: number;
    timeRange: [number, number];
  };
  stationId: number;
};

export type FetchStationTopPlayedEpisodesProps = {
  webStationId: string;
  range?: {
    timeRangeStart: number;
    timeRangeEnd: number;
  };
  limit: number;
};

export async function fetchStationTopPlayedEpisodes({
  webStationId,
  range,
  limit,
}: FetchStationTopPlayedEpisodesProps): Promise<FetchStationTopPlayedEpisodesResponse> {
  try {
    const resp = await fetch(
      getStationTopEpisodesUrl({
        webStationId,
        range,
        limit,
      }),
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );

    if (resp.ok) {
      return resp.json();
    }

    throw new Error("Could not fetch station's top episodes");
  } catch (err) {
    throw new Error(err.message);
  }
}

export function getStationTopEpisodesUrl({
  webStationId,
  range,
  limit,
  csvFilename,
}: FetchStationTopPlayedEpisodesProps & {
  csvFilename?: string;
}) {
  const queryParameters = {
    limit,
    ...(range && {
      timeRangeStart: range.timeRangeStart,
      timeRangeEnd: range.timeRangeEnd,
    }),
    ...(csvFilename && { csvFilename }),
  };

  return getApiUrl({
    path: `analytics/station/webStationId:${webStationId}/topEpisodes`,
    queryParameters,
  });
}
